<template>
    <div>

        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section-shaped my-0">
                <div class="shape shape-style-1 shape-default shape-skew">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-6">
                                <h1 class="display-3  text-white">Drawings and Doodles
                                    <!--<span>and the sort</span>-->
                                </h1>
                                <p class="lead  text-white">I like to draw in my free time some. I am in no way
                                    distinguished,
                                    but a few of my creations are here.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>

        <section v-bind:class="{'section': true, 'section-lg': i % 2 == 0, 'bg-secondary': i % 2 == 1}" v-for="(modal, i) in modals">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-md-2">
                        <img :src="modal.img" class="img-fluid rounded">
                    </div>
                    <div class="col-md-6 order-md-1">
                        <div class="pr-md-5">
                            <icon class="mb-5" size="lg" type="success" shadow
                                  rounded><font-awesome-icon icon="image"></font-awesome-icon></icon>
                            <h3>{{ modal.title }}</h3>
                            <p>{{ modal.desc }}</p>
                            <base-button tag="a"
                                         :href="modal.img"
                                         target="_blank"
                                         class="mb-3 mb-sm-0 text-white"
                                         type="primary">
                                <font-awesome-icon icon="image" size="lg"></font-awesome-icon> Full Image
                                <!--href="https://www.creative-tim.com/product/vue-argon-design-system"-->
                            </base-button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-lg"></section>
    </div>
</template>

<script>
  import Modal from '@/components/Modal.vue'
  import BTooltip from 'bootstrap-vue/src/components/tooltip/tooltip'

  export default {
    name: 'home',
    components: {BTooltip, Modal},
    data: () => ({
      modals: require('../../public/details/art'),
    }),
    methods: {
      goToLink (url) {
        let win = window.open(url, '_blank')
        win.focus()
      }
    }
  }
</script>